export default __webpack_public_path__ + "static/media/im2.fd109afe.jpg";